export default __webpack_public_path__ + "31954487de77044b59db3596bd426767.pdf";